import * as types from './types';

export default {
    [types.CAN_POST](state, posterStatus) {
        state.posterStatus.hasAuthorized = posterStatus.hasAuthorized;
        state.posterStatus.canPost = posterStatus.canPost;
        state.posterStatus.blackList = posterStatus.blackList;
    },
};
